import { api } from './api';
import {
  CannedResponse,
  CreateCannedResponseRequest,
  UpdateCannedResponseRequest,
} from '../types/cannedResponse';

class CannedResponseService {
  async getAll(search?: string): Promise<CannedResponse[]> {
    const response = await api.get<CannedResponse[]>('/canned-responses', {
      params: search ? { search } : undefined,
    });
    return response.data;
  }

  async getById(id: string): Promise<CannedResponse> {
    const response = await api.get<CannedResponse>(`/canned-responses/${id}`);
    return response.data;
  }

  async create(data: CreateCannedResponseRequest): Promise<CannedResponse> {
    const response = await api.post<CannedResponse>('/canned-responses', data);
    return response.data;
  }

  async update(id: string, data: UpdateCannedResponseRequest): Promise<CannedResponse> {
    const response = await api.put<CannedResponse>(`/canned-responses/${id}`, data);
    return response.data;
  }

  async delete(id: string): Promise<void> {
    await api.delete(`/canned-responses/${id}`);
  }
}

export const cannedResponseService = new CannedResponseService();
